const tokens = {
  defaultShadowColor: '#ffffff',
  defaultHoverShadowColor: '#ffffff',
  defaultActiveShadowColor: '#ffffff',
} as const

export default tokens
